var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import L from 'leaflet';
import React, { useEffect, useRef, useState, } from 'react';
import MapContext from './MapContext';
import useEvents from './utils/useEvents';
import useMapInstance from './utils/useMapInstance';
const MapContent = ({ children, events, }) => {
    const mapInstance = useMapInstance();
    useEvents(mapInstance, events);
    return React.createElement(React.Fragment, null, children);
};
const Map = (_a) => {
    var { children, events, options, setInstance } = _a, otherProps = __rest(_a, ["children", "events", "options", "setInstance"]);
    const [mapInstance, setMapInstance] = useState(null);
    const mapRef = useRef(null);
    useEffect(() => {
        if (mapRef.current === null) {
            return;
        }
        const map = new L.Map(mapRef.current, options);
        setMapInstance(map);
        if (setInstance) {
            setInstance(map);
        }
    }, []);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", Object.assign({ ref: mapRef }, otherProps)),
        mapInstance && (React.createElement(MapContext.Provider, { value: { mapInstance } },
            React.createElement(MapContent, { events: events }, children)))));
};
export default Map;
//# sourceMappingURL=Map.js.map